<template>
  <base-modal :id="id" @hide="onRiskModalClose">
    <template v-if="activity">
      <span class="assignment-subtitle text-uppercase">{{ $t('learning.assignments.courseAssignment', { courseName: grabI18NTranslation(course.attributes.name) }) }}</span>
      <h5 class="font-weight-bold m-0">{{ activity.attributes.name.en }}</h5>
      <p class="text-muted small-text">{{ $t('learning.assignments.dueDate', { datetime: new Date(member.attributes.metadata.due_at).toLocaleDateString("en-US") }) }}</p>
      <hr />
      <p class="small-text">{{ $t('learning.assignments.assignmentLink') }}</p>
      <div class="card" @click="openAssignmentLink">
        <div class="card-body bg-light bg-light-enhanced">
          <div class="grid-container">

            <div v-if="membershipForActivity(activity).attributes.success && membershipForActivity(activity).attributes.completion" class="icon">
              <div class="complete-assignment-container">
                <font-awesome-icon :icon="['fas', 'check-circle']" class="fa-2x text-white"></font-awesome-icon>
              </div>
            </div>
            <div v-else class="icon">
              <div v-if="new Date(membershipForActivity(activity).attributes.metadata.due_at) < new Date()">
                <font-awesome-icon :icon="['fas', 'alarm-exclamation']" class="fa-2x text-danger"></font-awesome-icon>
              </div>
              <div v-else-if="membershipForActivity(activity).attributes.metadata.in_progress">
                <font-awesome-icon :icon="['fal', 'hourglass-half']" class="fa-2x secondary"></font-awesome-icon>
              </div>
            </div>
            <div class="title">
              <p class="mb-0 font-weight-bold">{{ activity.attributes.name.en }}</p>
              <p v-if="member.attributes.success && member.attributes.completion" class="completed_date text-complete mb-0">{{ $t('learning.assignments.completedDate', { datetime: new Date(submission).toLocaleDateString("en-US") }) }}</p>
              <p v-else class="text-muted mb-0">{{ $t('learning.assignments.dueDate', { datetime: new Date(member.attributes.metadata.due_at).toLocaleDateString("en-US") }) }}</p>
            </div>
            <div class="chevron">
                <font-awesome-icon class="chevron" :icon="['fal', 'chevron-right']"></font-awesome-icon>
            </div>
          </div>

        </div>
      </div>
      <!-- Long Read -->
      <template v-if="activity.attributes.category === 'long_read'">
        <p class="small-text mt-3">{{ $t('learning.assignments.verification') }}</p>
        <div class="card" @click="completeActivity">
          <div class="card-body bg-light bg-light-enhanced">
            <div class="grid-container">
              <div class="icon" v-if="member.attributes.success && member.attributes.completion">
                <font-awesome-icon :icon="['fas', 'check-square']" class="text-complete" size="2x"></font-awesome-icon>
              </div>
              <div class="icon" v-else>
                <font-awesome-icon :icon="['fal', 'square']" class="text-complete" size="2x"></font-awesome-icon>
              </div>
              <div class="title">
                <p class="mb-0 font-weight-bold">{{ $t('learning.assignments.completed') }}</p>
              </div>
              <div class="chevron">

              </div>
            </div>
          </div>
        </div>
      </template>
      <p class="assignment-overview mt-4">{{ $t('learning.assignments.assignmentOverview') }}</p>
      <div class="assignment-description" v-html="renderedDescription"></div>
      <!-- Modal in a modal baby -->
      <base-modal id="risk-modal">
        <risk-status :show-profile="false"></risk-status>
      </base-modal>
      <base-modal id="rise-course-modal" @hide="onRiskModalClose">
        <iframe width="100%" height="85%" :src="member.attributes.external_url" frameborder="0" />
      </base-modal>
    </template>
  </base-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import marked from 'marked';
import DOMPurify from 'dompurify';
import LocaleHandling from '@/mixins/locale-handling';
import common from "@/mixins/common";
import SubmissionService from '@/services/submission.service';
import MemberService from '@/services/member.service';
import UserService from '@/services/user.service';

export default {
  name: 'ActivityModal',
  mixins: [common, LocaleHandling],
  components: {
    RiskStatus: () => import('@/views/risk-status/risk-status.vue'),
    BaseModal: () => import('@/components/base-modal/base-modal.vue'),
  },
  props: {
    id: {
      type: String,
      // required: true
    },
    activity: {
      type: Object,
      // required: true
    },
    member: {
      type: Object,
      // required: true
    },
    course: {
      type: Object,
      // required: true
    },
    submission: {
      type: String,
    },
  },
  data() {
    return {
      mitigationModalOpened: false,
    };
  },
  mounted() {
    this.log('ActivityModal -> mounted', 'currentSubmissions', this.currentSubmissions);
  },
  computed: {
    ...mapState(['currentUser', 'defaultOrganization', 'currentActivityMembers', 'currentSubmissions']),
    renderedDescription() {
      return DOMPurify.sanitize(marked(this.activity.attributes.description.en));
    },
  },
  methods: {
    ...mapMutations(['addCurrentSubmission', 'updateActivityMember', 'setCurrentSubmissions']),
    membershipForActivity(activity) {
      return this.currentActivityMembers.data.find(
        (data) => data.relationships.memberable.data.id === activity.id,
      );
    },
    completeActivity() {
      if (this.member.attributes.success && this.member.attributes.completion) {
        this.successGrowl(null, this.$t('learning.assignments.alreadyCompleted'));
      } else if (this.mitigationModalOpened) {
        const memberParams = {
          completion: true,
          success: true,
        };
        const submissionParams = {
          member_id: this.member.id,
          activity_id: this.activity.id,
        };
        // update your members and create a submission for risk activities
        Promise.all([
          MemberService.update(this.member.id, memberParams),
          SubmissionService.create(submissionParams),
        ]).then((responses) => {
          this.log('ActivityModal -> completeActivity', 'responses', responses);
          const [member, submission] = responses.map((res) => res.data);
          this.log('ActivityModal -> completeActivity', 'submission', submission);
          this.log('ActivityModal -> completeActivity', 'member', member);
          this.successGrowl(null, this.$t('learning.assignments.completed'));
          this.closeModal(this.id);
          if (submission) {
            const submissionIndex = this.findExistingSubmissionIndex(submission);
            if (submissionIndex === -1) {
              this.addCurrentSubmission(submission);
            }
          }
          const activityMemberIndex = this.findActivityMember(member);
          if (activityMemberIndex) {
            this.updateActivityMember({
              activityMemberIndex,
              activityMember: member,
            });
          }
        });
      } else {
        this.$notify({
          text: this.$t('learning.assignments.mitigationModalOpened'),
          type: 'error',
        });
      }
    },
    openAssignmentLink() {
      if (this.activity.attributes.category === 'long_read') {
        this.openModal('risk-modal');
        this.mitigationModalOpened = true;
      } else {
        const ua = window.navigator.userAgent;
        const isIE = /MSIE|Trident|Edge\//.test(ua);
        if (isIE) {
          const win = window.open(this.activity.attributes.external_url, '_blank');
          win.focus();
        } else {
          this.openModal('rise-course-modal');
        }
      }
    },
    onRiskModalClose() {
      const secondsSinceEpoch = Math.round(Date.now() / 1000);
      const memberId = this.member.id;
      this.log('ActivityModal -> onRiskModalClose', 'memberId', memberId);
      if (this.activity.attributes.category !== 'long_read') {
        // run the api call to xapi sync, and then fetch the submission based on this activity.
        UserService.xApiSync(this.currentUser.data.id, this.defaultOrganization.data.id)
          .then(() => {
            this.getAllSubmissions();
            return MemberService.show(memberId, { timestamp: secondsSinceEpoch });
          })
          .then((response) => {
            const member = response.data;
            this.log('ActivityModal -> onRiskModalClose -> USerService.xApiSync -> MemberService.show', 'member', member);
            const activityMemberIndex = this.findActivityMember(member);
            this.log('ActivityModal -> onRiskModalClose -> USerService.xApiSync -> MemberService.show', 'activityMemberIndex', activityMemberIndex);
            if (activityMemberIndex) {
              this.updateActivityMember({
                activityMemberIndex,
                activityMember: member,
              });
            }
          });
      }
    },
    getAllSubmissions() {
      const secondsSinceEpoch = Math.round(Date.now() / 1000);
      const params = {
        timestamp: secondsSinceEpoch,
        per_page: 250,
      };
      UserService.submissions(this.currentUser.data.id, this.defaultOrganization.data.id, params).then((response) => {
        this.log('ActivityModal -> getAllSubmissions', 'response', response);
        this.setCurrentSubmissions(response);
      });
    },
    findExistingSubmissionIndex(submission) {
      let result = -1;
      if (submission) {
        this.log('ActivityModal -> findExistingSubmission', 'submission', submission);
        if (this.currentSubmissions && this.currentSubmissions.data) {
          for (let i = 0; i < this.currentSubmissions.data.length; i += 1) {
            const currentSubmission = this.currentSubmissions.data[i];
            this.log('ActivityModal -> findExistingSubmission', 'currentSubmission', currentSubmission);
            if (currentSubmission) {
              if (currentSubmission.id === `${submission.id}`) {
                result = i;
                break;
              }
            }
          }
        }
      }
      return result;
    },
    findActivityMember(member) {
      let result = -1;
      if (member) {
        if (this.currentActivityMembers && this.currentActivityMembers.data) {
          for (let i = 0; i < this.currentActivityMembers.data.length; i += 1 ) {
            const activityMember = this.currentActivityMembers.data[i];
            if (activityMember) {
              if (activityMember.id === `${member.id}`) {
                result = i;
                break;
              }
            }
          }
        }
      }
      return result;
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">
</style>
